// services/consultar_cliente.js
export const consultarCliente = async(requestBody) => {
    try {
        // Configuración de la API - actualiza la URL según sea necesario
        const API_URL = 'https://hosting-visioner7.com/api/v1_apiVisioner7/consultacliente.php';

        const token = localStorage.getItem('auth_token');

        if (!token) {
            return {
                success: false,
                error: 'No hay sesión activa'
            };
        }

        const response = await fetch(API_URL, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            mode: 'cors',
            body: JSON.stringify(requestBody),
        });

        // No lanzar error aquí, procesar la respuesta siempre
        const data = await response.json();
        
        // Agregar el status code a la respuesta
        return {
            ...data,
            status_code: response.status
        };
        
    } catch (error) {
        console.error('Error en consultarCliente:', error);
        // Retornar un objeto estructurado incluso en caso de error
        return {
            success: false,
            status_code: 0,
            message: error.message || 'Error de conexión',
            environment: 'ERROR',
            data: {
                messages: [{
                    code: 'connection_error',
                    message: error.message || 'Error de conexión con el servidor',
                    type: 'ERROR'
                }]
            }
        };
    }
};